import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Login.css';

const STATUS_COPY = {
  pending: {
    title: 'Request Pending Review',
    message: 'Your email is verified and your access request is pending admin review. You will receive an email when your request is accepted or denied.'
  },
  exists: {
    title: 'Account Already Exists',
    message: 'An account already exists for this email. Sign in or use Forgot Password to reset access.'
  },
  invalid: {
    title: 'Verification Link Invalid',
    message: 'This verification link is invalid or expired. Submit a new request access form to continue.'
  }
};

function RequestAccessStatus() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const state = String(params.get('state') || '').trim().toLowerCase();
  const status = STATUS_COPY[state] || STATUS_COPY.invalid;

  return (
    <div className="login-container">
      <h2>{status.title}</h2>
      <div
        style={{
          marginBottom: '1rem',
          fontSize: '0.95rem',
          color: '#0b4f8a',
          backgroundColor: '#eef6ff',
          border: '1px solid #cfe7ff',
          borderRadius: 6,
          padding: '0.75rem 0.9rem',
          lineHeight: 1.45
        }}
      >
        {status.message}
      </div>

      <div className="login-links" role="group" aria-label="Request access status links">
        <Link to="/login" className="link-btn">Back to Sign In</Link>
        <Link to="/request-access" className="link-btn">Submit New Request</Link>
      </div>
    </div>
  );
}

export default RequestAccessStatus;
